import Enhancer from '../enhancer.js';
import EnhancerApp from '../enhancer-app.js';

export default class CollapseButton extends Enhancer {

    collapsedSelector = '.collapse-btn-collapsed';
    expandedSelector = '.collapse-btn-expanded';

    init() {
        if (this.expanded) {
            this.handleHide();
            
        }
        else {
            this.handleShow();
        }

        this.element.addEventListener('click', this.handleClick.bind(this));
    }

    handleClick() {
        /* Hide and show inversed on click since bootstrap collapse updates 
         * the aria-expanded attribute before our click event triggers 
         */
        if (this.expanded) {
            this.handleShow();
        }
        else {
            this.handleHide();
        }
    }

    handleShow() {
        this.get(this.collapsedSelector).style.display = null;
        this.get(this.expandedSelector).style.display = 'none';
    }

    handleHide() {
        this.get(this.collapsedSelector).style.display = 'none';
        this.get(this.expandedSelector).style.display = null;
    }

    get expanded() {
        return this.element.getAttribute('aria-expanded') === 'true';
    }

}

EnhancerApp.register('CollapseButton', CollapseButton);